import { mdiBellOutline } from '@mdi/js';
import i18n from 'es2015-i18n-tag';
import { default as React, useState } from 'react';
import Dialog from '../../../../../common/ui-components/dialog/dialog.component';
import IconButton from '../../../../../common/ui-components/icon-button/icon-button.component';
import { RemindMembersDialog } from '../remind-members-dialog/remind-members-dialog.component';

export const RemindMembersButton = ({ onClick }) => {
    const [showDialog, setShowDialog] = useState(false);
    const onCancel = () => setShowDialog(false);
    const onConfirm = () => {
        setShowDialog(false);
        onClick();
    };
    return (
        <>
            <IconButton
                icon={mdiBellOutline}
                title={i18n`Mitglieder an Umfrage erinnern`}
                onClick={() => setShowDialog(true)}
            />
            <Dialog isOpen={showDialog}>
                <RemindMembersDialog onCancel={onCancel} onConfirm={onConfirm} />
            </Dialog>
        </>
    );
};
